module.exports = __webpack_public_path__ + "static/hygiene_rating-aeb6970f63b643ac5ef7ea16090b10fc.jpg";